import { useState } from "react";
import PageHeader from "../../components/pageHeader";
import MainContentLayout from "../../components/mainContentLayout";
import UpcomingTab from "./upcomingTab";
import CoachActivitiesTab from "./coachActivitiesTab";
import PublicActivitiesTab from "./publicActivitiesTab";
import { useSelector } from "react-redux";

export default function PlayerActivitiesPage() {
  const user = useSelector((s) => s.user.user);
  const hasCoach = Boolean(user?.coachId);

  const [activeTab, setActiveTab] = useState("upcoming");

  return (
    <MainContentLayout>
      <PageHeader title="Activities" backTo="/dashboard" />

      {/* Tabs */}
      <div className="flex justify-center mt-3 border-b">
        <button
          onClick={() => setActiveTab("upcoming")}
          className={`px-4 py-2 text-sm font-medium border rounded-t-md ${
            activeTab === "upcoming"
              ? "bg-blue-600 text-white"
              : "bg-white-200 text-gray-700"
          }`}
        >
          Upcoming
        </button>

        {hasCoach && (
          <button
            onClick={() => setActiveTab("coach")}
            className={`px-4 py-2 text-sm font-medium border rounded-t-md ${
              activeTab === "coach"
                ? "bg-blue-600 text-white"
                : "bg-white-200 text-gray-700"
            }`}
          >
            Coach's Activities
          </button>
        )}

        <button
          onClick={() => setActiveTab("public")}
          className={`px-4 py-2 text-sm font-medium border rounded-t-md ${
            activeTab === "public"
              ? "bg-blue-600 text-white"
              : "bg-white-200 text-gray-700"
          }`}
        >
          General Activities
        </button>
      </div>

      <div className="mt-6">
        {activeTab === "upcoming" && <UpcomingTab />}
        {activeTab === "coach" && hasCoach && <CoachActivitiesTab />}
        {activeTab === "public" && <PublicActivitiesTab />}
      </div>
    </MainContentLayout>
  );
}
